import olMap from './olMap';

export default olMap;
